import type { FunctionComponent } from "react";

import { StyledMynewsHeader } from "scmp-app/components/my-news/init-mynews/styles";

import { LoadingImage, LoadingScreenContainer, LoadingText } from "./styles";

export const MynewsLoading: FunctionComponent = () => (
  <div>
    <StyledMynewsHeader isShowIndicatorIcon />
    <LoadingScreenContainer>
      <LoadingImage src="https://assets.i-scmp.com/static/img/gifs/wheel_on_E5E5E5.gif" />
      <LoadingText>
        LOADING <i>my</i>
        <span>NEWS</span>
      </LoadingText>
    </LoadingScreenContainer>
  </div>
);
MynewsLoading.displayName = "MynewsLoading";
